module.exports = __webpack_public_path__ + "static/media/icon_publish_white.fef8c515.svg";